// 登录login
import axios from '@/libs/api.request'

// 邮箱登录接口
export const authLogin = (data) => {
  return axios.request({
    data: data,
    url: `/auth-center/login`,
    method: 'post',
    headers: {
      isLogin: true
    }
  })
}
// 登录过期后续期
export const renewalLogin = () => {
  return axios.request({
    url: `/auth-center/logout`,
    method: 'post',
    headers: {
      'accesstoken': sessionStorage.getItem('token')
    }
  })
}

// 登出
export const authLogout = () => {
  return axios.request({
    url: `/auth-center/logout`,
    method: 'post',
    headers: {
      noEncryption: true
    }
  })
}

// 当前登录用户信息
export const userInfo = (data) => {
  return axios.request({
    data: data,
    url: `/auth-center/user-info`,
    method: 'post'

  })
}

// 新增用户
export const addUser = (data) => {
  return axios.request({
    data: data,
    url: `/user-center/register-user`,
    method: 'post'

  })
}
// 编辑用户
export const editUser = (data) => {
  return axios.request({
    data: data,
    url: `/user-center/update-user`,
    method: 'post'

  })
}
// 启用与禁用用户

export const changeUserStatus = (data) => {
  return axios.request({
    data: data,
    url: `/user-center/user/toggle-status`,
    method: 'post'

  })
}
// 删除用户
export const deleteUser = (data) => {
  return axios.request({
    url: `/user-center/delete-user/` + data,
    method: 'post'

  })
}

// 用户列表
export const getUserList = (data) => {
  return axios.request({
    data: data,
    url: `/user-center/user/list-page`,
    method: 'post'

  })
}

// 角色列表
export const getRoleList = (data) => {
  return axios.request({
    data: data,
    url: `/user-center/role/list-page`,
    method: 'post'
  })
}

// 添加角色
export const roleAdd = (data) => {
  return axios.request({
    url: `/user-center/add-roles`,
    method: 'post',
    data
  })
}

// 查看角色
export const roleView = (roleId) => {
  return axios.request({
    url: `/user-center/search/role/id/${roleId}`,
    method: 'post'
  })
}

// 更新角色
export const roleEdit = (data) => {
  return axios.request({
    url: `/user-center/update-role`,
    method: 'post',
    data
  })
}

// 删除角色
export const roleDelete = (roleId) => {
  return axios.request({
    url: `/user-center/delete-role/${roleId}`,
    method: 'post'
  })
}

// 权限列表
export const getpermissionList = (data) => {
  return axios.request({
    data: data,
    url: `/user-center/permission/list-page`,
    method: 'post'

  })
}

// 添加权限
export const permissionAdd = (data) => {
  return axios.request({
    url: `/user-center/add-permissions`,
    method: 'post',
    data
  })
}

// 更新权限
export const permissionEdit = (data) => {
  return axios.request({
    url: `/user-center/update-permission`,
    method: 'post',
    data
  })
}

// 删除权限
export const permissionDelete = (permissionId) => {
  return axios.request({
    url: `/user-center/delete-permission/${permissionId}`,
    method: 'post'
  })
}

// 为用户绑定多个角色
export const bindUserRoles = (userId, roleIds) => {
  return axios.request({
    url: '/user-center/user/bind-roles',
    method: 'POST',
    data: {
      userId,
      roleIds
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 获取用户角色权限（路径参数示例）已绑定的
export function getUserRolePermissions(userId) {
  return axios.request({
    url: `/user-center/search/code/roles-permissions/${userId}`, // 注意路径参数拼接
    method: 'post'
  })
};

// 获取用户已绑定的角色
export function getUserRole(userId) {
  return axios.request({
    url: `/user-center/search/user-bind-roles/${userId}`, // 注意路径参数拼接
    method: 'post'
  })
};
// 获取角色已绑定的权限
export function getRolePerm(roleId) {
  return axios.request({
    url: `/user-center/search/role-bind-permissions/${roleId}`, // 注意路径参数拼接
    method: 'post'
  })
};

// 为用户解绑多个角色
export const unbindUserRoles = (userId, roleIds) => {
  return axios.request({
    url: '/user-center/user/unbind-roles',
    method: 'POST',
    data: {
      userId,
      roleIds
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 为角色绑定多个权限
export const bindRolesPerm = (roleId, permissionIds) => {
  return axios.request({
    url: '/user-center/role/bind-permissions',
    method: 'POST',
    data: {
      roleId,
      permissionIds
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 为角色解绑多个权限 userId roleIds
export const unbindRolesPerm = (roleId, permissionIds) => {
  return axios.request({
    url: '/user-center/role/unbind-permissions',
    method: 'POST',
    data: {
      roleId,
      permissionIds
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 为角色绑定多个菜单
export const bindMenu = (roleId, menuIds) => {
  return axios.request({
    url: '/user-center/role/bind-menus',
    method: 'POST',
    data: {
      roleId, menuIds
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
// 为角色绑定多个菜单
export const unbindMenu = (roleId, menuIds) => {
  return axios.request({
    url: '/user-center/role/unbind-menus',
    method: 'POST',
    data: {
      roleId, menuIds
    },
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function RoleMenu(menuId) {
  return axios.request({
    url: `/user-center/search/menu/id/${menuId}`, // 注意路径参数拼接
    method: 'post'
  })
};

// 根据Role Id 来查询所拥有的菜单
export function RolePermissions(roleId) {
  return axios.request({
    url: `/user-center/search/role-bind-menus/${roleId}`, // 固定路径
    method: 'post'
  })
}

// 修改密码-当前登录用户
export function updatePassword(data) {
  return axios.request({
    url: '/auth-center/password/update',
    method: 'post',
    data
  })
}


// 简单搜索
export const userSimpleSearch = (data) => {
  return axios.request({
    url: `/user-center/user/simple/list-page`,
    method: 'post',
    data
  })
}

// 复杂搜索
export const userSeniorSearch = (params) => {
  return axios.request({
    url: '/user-center/user/condition/list-page',
    method: 'post',
    data: params
  })
}